export default __webpack_public_path__ + "static/media/berit-schulen-logo.7cd24f57.png";